import { DefaultTheme } from 'styled-components';

export const fillColor = (active: boolean, theme: DefaultTheme): string =>
  active ? theme.colorTokens.button.secondary.default : theme.colorTokens.surface.background;
export const textColor = (active: boolean, theme: DefaultTheme): string =>
  active ? theme.colorTokens.text.brand : theme.colorTokens.text.strong;
